export default "<div flex layout layout-align=\"center center\" class=gw-search-locations ng-form=$ctrl.locationsForm> <gw-form-country class=\"u-1/1 u-1/3@tablet\" [(country)]=$ctrl.country></gw-form-country> <button class=\"gw-button u-ml u-ph-small u-ph-med@tablet\" ng-click=$ctrl.search($ctrl.country)> Search </button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/common/directory/countries/search-countries.html
// module id = XEkI
// module chunks = 1